export default __webpack_public_path__ + "static/media/inbal_mizrach.b4156c7e.png";